import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Form, Spin, Col, Image, message, Row,
  Tooltip
} from "antd";
import {
  PlusOutlined, DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../../../../assets/images/icons/userLogo.svg";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../../../../store";
import { aboutUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../../../utils";
import { sortDataByOrder } from "../../../../../../utils/helper"
import userServiceApi from "../../../../../../api/userServiceApi";
import reArrangeOrder from "../../../../../common/DragAndDropList/rearrangeHelper";
import { DragAndDropList } from "../../../../../../components/common";

const { TextArea } = Input;
const MAX_CHARACTERS = 500;

export default function AccreditationComponent({
  dataLoader,
  form,
  activeKey,
}) {
  const { state } = useLocation();
  const tabKey = state;
  const { tabData } = useStore();
  const tabConfigId = localStorage.getItem("selectedTabId");
  const { micrositeId } = useParams();
  const whichTab = aboutUSkeys.Accreditation;
  const { updateAccreditationImage } = useConnectsuForm();
  const [loader, setLoader] = useState(true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();
 const { deleteSingleItem, postLoader } = useTab();

  // New state to track unsaved items
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);
  const [canAddNew, setCanAddNew] = useState(true);

  if (activeKey === "ABOUT_US") {
    localStorage.setItem("tab", activeKey);
  }

  useEffect(() => {
    setFormChanged(false);
    setCanAddNew(true);
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;
    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);



  const renderMedia = (dataItem) => {
    const commonStyles = {
      display: "flex",
      justifyContent: "center",
    };

    const imageUrl =
      dataItem?.awardsLogos?.url || // accreditation image from form state
      dataItem?.mediaLink?.url ||   // fallback (about us team style)
      dataItem?.aboutUsTeamDataOutPut?.image?.url; // backend state fallback

    if (imageUrl) {
      return (
        <div className={`iframe-comp IMAGE`} style={commonStyles}>
          <img
            src={imageUrl}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }

    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };

  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];

    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.awardsLogos?.url ||
        item?.awardsLogos?.name;
      return !item?.id && hasData;
    });

    if (unsavedItem) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    // ✅ Prepend new empty row at the top
    const newList = [{}, ...currentList];
    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);
  };

  const handleSave = () => {
    form.submit();
    setTimeout(() => {
      setCanAddNew(true);
      setHasUnsavedItem(false);
    }, 500);
  };

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item =>
      !item?.id &&
      (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
    );
    setCanAddNew(!unsavedItem);
    // setHasUnsavedItem(!!unsavedItem);
  };

  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];

    // Reset unsaved row(s)
    const updatedList = currentList.map(item =>
      !item?.id ? { title: "", description: "", awardsLogos: { name: "", url: "" } } : item
    );

    form.setFieldsValue({ [whichTab]: updatedList });

    // Unlock if no unsaved items
    const unsavedItem = updatedList.find(item =>
      !item?.id &&
      (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
    );

    setCanAddNew(!unsavedItem);
    // setHasUnsavedItem(!!unsavedItem);

    refreshUnsavedState()
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.ACCREDITATIONS_AWARDS?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.ACCREDITATIONS_AWARDS]);


  const handleDelete = (whichTab, form, i, tabKey) => {
    const item = form.getFieldValue(whichTab)?.[i];
    const id = item?.id;

    if (id) {
      // Delete from backend
      deleteSingleItem(whichTab, id, form);
    } else {
      // Just remove from form (unsaved/new row)
      const currentList = form.getFieldValue(whichTab) || [];
      currentList.splice(i, 1);
      form.setFieldsValue({ [whichTab]: currentList });
    }


    setTimeout(() => {
      const currentList = form.getFieldValue(whichTab) || [];
      const unsavedItem = currentList.find(item =>
        !item?.id &&
        (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
      );

      setCanAddNew(!unsavedItem);
      setHasUnsavedItem(!!unsavedItem);
      refreshUnsavedState()
    }, 100);
  };

  useEffect(() => {
    form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
      setCanAddNew(true);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData[whichTab]]);

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="newContantStyle">
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <div className="ant-col ant-col-24 gutter-row tabContent" style={{ paddingLeft: "16px", paddingRight: "16px"}}>
            {tabKey.split("/")[1] === whichTab ? (
              <>
                <Col className="gutter-row tabContent" span={24}>
                  <div className="w-100">
                    <Form.List
                      name={whichTab}
                      initialValue={
                        tabData &&
                          tabData[whichTab] &&
                          tabData[whichTab].length > 0
                          ? sortDataByOrder(tabData[whichTab])
                          : [{}]
                      }
                    >
                      {(fields, { add, remove, move }) => {
                      return(
                        <div className="w-100">
                          <Col
                            className="gutter-row tabContent"
                            xs={24}
                            sm={24}
                            md={14}
                            lg={14}
                            style={{ paddingRight: "25px" }}
                          >
                            <div className="inputBody w-100">
                              <div style={{ textAlign: "right" }}>
                                {hasUnsavedItem && (
                                  <Button
                                    className="cancelBtn"
                                    type="button"
                                    onClick={handleClear}
                                  >
                                    Clear
                                  </Button>
                                )}
                                <Button
                                  className="greenBtn"
                                  onClick={handleAddMore}
                                >
                                  Add <PlusOutlined />
                                </Button>
                              </div>
                            </div>
                          </Col>

                          <Col
                            className="gutter-row tabContent"
                            xs={24}
                            sm={24}
                            md={10}
                            lg={10}
                          >
                          </Col>
                          <DragAndDropList
                            fields={fields}
                            move={move}
                            form={form}
                            fieldName={whichTab}
                            onReorder={(payload) => reArrangeOrder(
                              userServiceApi.reArrangeDataInAboutUs({
                                tabConfigId,
                                micrositeId,
                                aboutUsEnum: "ACCREDITATIONS_AWARDS",
                              }),
                              payload
                            )}
                            renderItem={({ key, name, ...restField }, i) => {
                              const formItem =
                                form.getFieldValue([whichTab, i]) || {};
                              const backendItem = tabData[whichTab]?.[i];
                              const hasTitle =
                                (formItem.title &&
                                  formItem.title.trim() !== "") ||
                                (backendItem &&
                                  backendItem.title &&
                                  backendItem.title.trim() !== "");
                              const hasId = backendItem && backendItem.id;
                              return (
                              <div className="card-item">
                                <Col
                                  className="gutter-row tabContent"
                                  xs={24}
                                  sm={24}
                                  md={14}
                                  lg={14}
                                  style={{ paddingRight: "25px" }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <Form.Item
                                      className="w-100"
                                      {...restField}
                                      label="Name/Title"
                                      name={[name, "title"]}
                                      labelCol={{ span: 5 }}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Title is required",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Enter Title"
                                        maxLength={40}
                                        showCount={{
                                          formatter: ({ count }) => `${count}/40`,
                                        }}
                                        onKeyDown={(e) => {
                                          const currentValue = form.getFieldValue([whichTab, name, "title"]) || "";

                                          if (
                                            e.key.length === 1 &&
                                            currentValue.length >= 40
                                          ) {
                                            form.setFields([
                                              {
                                                name: [whichTab, name, "title"],
                                                errors: ["Title cannot exceed 40 characters"],
                                              },
                                            ]);
                                          }
                                        }}
                                        onBlur={() => {
                                          form.setFields([
                                            {
                                              name: [whichTab, name, "title"],
                                              errors: [],
                                            },
                                          ]);
                                        }}
                                      />
                                    </Form.Item>
                                    <div
                                      className="remove-btn"
                                      style={{ position: "relative" }}
                                    >
                                      <DeleteOutlined
                                        style={{ cursor: "pointer" }}
                                        title="Delete Team"
                                        onClick={() => {
                                          if (hasTitle === false) return;
                                          if (hasId) {
                                            handleDelete(
                                              whichTab,
                                              form,
                                              i,
                                              tabKey
                                            );
                                          } else {
                                            remove(name);
                                            setHasUnsavedItem(false);
                                            refreshUnsavedState();
                                          }
                                          setCanAddNew(true);
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div style={{ display: "flex" }}>
                                    <Form.Item
                                      className="w-100"
                                      label="Description"
                                      {...restField}
                                      labelCol={{ span: 5 }}
                                      name={[name, "description"]}
                                      rules={[
                                        {
                                          required: true,
                                          message: "Description is required",
                                        },
                                        {
                                          max: MAX_CHARACTERS - 1,
                                          message: `Description should be less than ${MAX_CHARACTERS} character`,
                                        },
                                      ]}
                                    >
                                      <TextArea
                                        placeholder="Enter Description"
                                        rows={5}
                                        maxLength={MAX_CHARACTERS}
                                        showCount
                                      />
                                    </Form.Item>
                                  </div>
                                  <Form.Item
                                    {...restField}
                                    label="Accreditation"
                                    colon={false}
                                    name="awardsLogos.name"
                                    className="experienceImg uploadedImage"
                                    labelCol={{ span: 5 }}
                                  >
                                    {findValue(i, "blob") ? (
                                      <Image
                                        src={URL.createObjectURL(
                                          findValue(i, "blob")
                                        )}
                                        alt=""
                                      />
                                    ) : form.getFieldValue(whichTab)[i]
                                      ?.awardsLogos?.url ? (
                                      <Image
                                        src={
                                          form.getFieldValue(whichTab)[i]
                                            .awardsLogos.url
                                        }
                                        alt=""
                                      />
                                    ) : (
                                      <Image src={UserIcon} alt="" />
                                    )}
                                    <div>
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center'
                                      }}>
                                        <label
                                          name="file"
                                          className="fileUploadBtn greenBtn"
                                        >
                                          {" "}
                                          Upload image
                                          <input
                                            accept="image/png, image/gif, image/jpeg"
                                            type="file"
                                            onChange={(e) =>
                                              updateAccreditationImage(
                                                e,
                                                i,
                                                form,
                                                whichTab
                                              )
                                            }
                                          />
                                        </label>
                                        <Tooltip
                                          className="question"
                                          title={"Recommended image dimensions: 1280x720 pixels"}
                                        >
                                          <QuestionCircleOutlined />
                                        </Tooltip>
                                      </div>
                                      <div style={{ marginLeft: '12px', marginTop: '5px' }} className="">Add or Edit</div>

                                    </div>

                                  </Form.Item>

                                  <Form.Item
                                    className="w-100"
                                    style={{
                                      display: "flex",
                                      justifyContent: "end",
                                    }}
                                  >
                                    {formChanged ? (
                                      <Button
                                        className="saveBtn greenBtn"
                                        onClick={handleSave}
                                      >
                                        Save
                                      </Button>
                                    ) : (
                                      <Button
                                        className="saveBtn greenBtn"
                                        style={{
                                          opacity: "0.5",
                                          pointerEvents: "none",
                                        }}
                                      >
                                        Save
                                      </Button>
                                    )}
                                  </Form.Item>
                                </Col>
                                <Col
                                  className="gutter-row tabContent"
                                  xs={24}
                                  sm={24}
                                  md={10}
                                  lg={10}
                                >
                                  <div>
                                    {form.getFieldValue(whichTab)?.[i]
                                      ?.awardsLogos
                                      ? renderMedia({
                                        mediaLink: {
                                          url: form.getFieldValue(whichTab)[i]
                                            .awardsLogos.url,
                                        },
                                      })
                                      : null}
                                  </div>
                                </Col>
                              </div>
                            );
                          }}
                          />
                        </div>
                      )
                      }}
                    </Form.List>

                  </div>
                </Col>
              </>
            ) : (
              <></>
            )}
          </div>
        </Row>
      </div>
    );
  }
}